export default __webpack_public_path__ + "static/media/Tutorial-Step-3.1.f7a844a3.jpg";